import { useState } from 'react'

import { useRequiredParams } from '@percent/admin-dashboard/common/hooks'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { useMutation, useQuery } from '@percent/utility'
import { CreateStaticLink } from './CreateStaticLink'
import { CreateStaticLinkFormModel } from './CreateStaticLink.types'

export function CreateStaticLinkContainer() {
  const { id: partnerId } = useRequiredParams()
  const { validationSubmissionsService, adminService } = useServices()
  const [slugConfigModalStatus, setSlugConfigModalStatus] = useState<'success' | 'error' | null>(null)

  const { data: configurations, isLoading: isLoadingConfigurations } = useQuery(
    ['validation-submission-configurations', partnerId],
    validationSubmissionsService.getValidationSubmissionConfigurations,
    { partnerId, pageSize: 100 }
  )

  const [{ isPending: isSaving }, { mutateAsync: createStaticLink }] = useMutation(
    adminService.commands.createStaticLink,
    () => setSlugConfigModalStatus('success'),
    () => setSlugConfigModalStatus('error')
  )

  const handleSubmit = async (values: CreateStaticLinkFormModel) => {
    setSlugConfigModalStatus(null)

    await createStaticLink({
      partnerId,
      payload: {
        slug: values.slug,
        validationSubmissionConfigurationId: values.validationSubmissionConfigurationId,
        redirectUrl: values.redirectUrl || null,
        isEnabled: values.isEnabled,
        enablePost: values.enablePost,
        allowedOrigin: values.enablePost && values.allowedOrigin ? values.allowedOrigin : null
      }
    })
  }

  return (
    <CreateStaticLink
      configurations={configurations ?? []}
      isLoadingConfigurations={isLoadingConfigurations}
      onSubmit={handleSubmit}
      isSaving={isSaving}
      slugConfigModalStatus={slugConfigModalStatus}
      setSlugConfigModalStatus={setSlugConfigModalStatus}
    />
  )
}
